import ArrowDownToBaseIconPath from "@ingka/ssr-icon/paths/arrow-down-to-base";

export default ArrowDownToBaseIconPath;
